// Check convert-currency-platform in the scripts repository for creating a new version of this

export type CurrencyData = { symbol: string; name: string };

export const ISOCurrency: Record<string, CurrencyData> = {
  AED: { symbol: "د.إ.", name: "United Arab Emirates Dirham" },
  AFN: { symbol: "Af", name: "Afghan Afghani" },
  ALL: { symbol: "L", name: "Albanian Lek" },
  AMD: { symbol: "֏", name: "Armenian Dram" },
  ANG: { symbol: "ƒ", name: "Netherlands Antillean Guilder" },
  AOA: { symbol: "Kz", name: "Angolan Kwanza" },
  ARS: { symbol: "AR$", name: "Argentine Peso" },
  AUD: { symbol: "AU$", name: "Australian Dollar" },
  AWG: { symbol: "ƒ", name: "Aruban Florin" },
  AZN: { symbol: "ман", name: "Azerbaijani Manat" },
  BAM: { symbol: "KM", name: "Bosnia and Herzegovina Convertible Mark" },
  BBD: { symbol: "BBD$", name: "Barbadian Dollar" },
  BDT: { symbol: "৳", name: "Bangladeshi Taka" },
  BGN: { symbol: "лв.", name: "Bulgarian Lev" },
  BHD: { symbol: "BD", name: "Bahraini Dinar" },
  BIF: { symbol: "FBu", name: "Burundian Franc" },
  BMD: { symbol: "$", name: "Bermudian Dollar" },
  BND: { symbol: "B$", name: "Brunei Dollar" },
  BOB: { symbol: "Bs.", name: "Bolivian Boliviano" },
  BRL: { symbol: "R$", name: "Brazilian Real" },
  BSD: { symbol: "$", name: "Bahamian Dollar" },
  BTN: { symbol: "Nu.", name: "Bhutanese Ngultrum" },
  BWP: { symbol: "P", name: "Botswana Pula" },
  BYN: { symbol: "Br", name: "Belarusian Ruble" },
  BZD: { symbol: "BZ$", name: "Belize Dollar" },
  CAD: { symbol: "CA$", name: "Canadian Dollar" },
  CDF: { symbol: "FC", name: "Congolese Franc" },
  CHF: { symbol: "Fr.", name: "Swiss Franc" },
  CKD: { symbol: "$", name: "Cook Islands Dollar" },
  CLP: { symbol: "CL$", name: "Chilean Peso" },
  CNY: { symbol: "CN¥", name: "Chinese Yuan" },
  COP: { symbol: "CO$", name: "Colombian Peso" },
  CRC: { symbol: "₡", name: "Costa Rican Colon" },
  CUC: { symbol: "CUC$", name: "Cuban convertible Peso" },
  CUP: { symbol: "$MN", name: "Cuban Peso" },
  CVE: { symbol: "CV$", name: "Cabo Verdean Escudo" },
  CZK: { symbol: "Kč", name: "Czech Koruna" },
  DJF: { symbol: "Fdj", name: "Djiboutian Franc" },
  DKK: { symbol: "kr.", name: "Danish Krone" },
  DOP: { symbol: "RD$", name: "Dominican Peso" },
  DZD: { symbol: "DA", name: "Algerian Dinar" },
  EGP: { symbol: "E£", name: "Egyptian Pound" },
  EHP: { symbol: "Ptas.", name: "Sahrawi Peseta" },
  ERN: { symbol: "Nkf", name: "Eritrean Nakfa" },
  ETB: { symbol: "Br", name: "Ethiopian Birr" },
  EUR: { symbol: "€", name: "Euro" },
  FJD: { symbol: "FJ$", name: "Fijian Dollar" },
  FKP: { symbol: "FK£", name: "Falkland Islands Pound" },
  FOK: { symbol: "kr", name: "Faroese Króna" },
  GBP: { symbol: "£", name: "Pound Sterling" },
  GEL: { symbol: "₾", name: "Georgian Lari" },
  GGP: { symbol: "£", name: "Guernsey Pound" },
  GHS: { symbol: "GH₵", name: "Ghanaian Cedi" },
  GIP: { symbol: "£", name: "Gibraltar Pound" },
  GMD: { symbol: "D", name: "Gambian Dalasi" },
  GNF: { symbol: "FG", name: "Guinean Franc" },
  GTQ: { symbol: "Q", name: "Guatemalan Quetzal" },
  GYD: { symbol: "G$", name: "Guyanese Dollar" },
  HKD: { symbol: "HK$", name: "Hong Kong Dollar" },
  HNL: { symbol: "L", name: "Honduran Lempira" },
  HRK: { symbol: "kn", name: "Croatian Kuna" },
  HTG: { symbol: "G", name: "Haitian Gourde" },
  HUF: { symbol: "Ft", name: "Hungarian Forint" },
  IDR: { symbol: "Rp", name: "Indonesian Rupiah" },
  ILS: { symbol: "₪", name: "Israeli new Shekel" },
  IMP: { symbol: "£", name: "Manx Pound" },
  INR: { symbol: "Rs.", name: "Indian Rupee" },
  IQD: { symbol: "د.ع.", name: "Iraqi Dinar" },
  IRR: { symbol: "﷼", name: "Iranian Rial" },
  ISK: { symbol: "kr", name: "Icelandic Krona" },
  JEP: { symbol: "£", name: "Jersey Pound" },
  JMD: { symbol: "J$", name: "Jamaican Dollar" },
  JOD: { symbol: "JD", name: "Jordanian Dinar" },
  JPY: { symbol: "¥", name: "Japanese Yen" },
  KES: { symbol: "KSh", name: "Kenyan Shilling" },
  KGS: { symbol: "с", name: "Kyrgyzstani Som" },
  KHR: { symbol: "៛", name: "Cambodian Riel" },
  KID: { symbol: "$", name: "Kiribati Dollar" },
  KMF: { symbol: "CF", name: "Comorian Franc" },
  KPW: { symbol: "₩", name: "North Korean Won" },
  KRW: { symbol: "₩", name: "South Korean Won" },
  KWD: { symbol: "KD", name: "Kuwaiti Dinar" },
  KYD: { symbol: "CI$", name: "Cayman Islands Dollar" },
  KZT: { symbol: "₸", name: "Kazakhstani Tenge" },
  LAK: { symbol: "₭N", name: "Lao Kip" },
  LBP: { symbol: "LL.", name: "Lebanese Pound" },
  LKR: { symbol: "Rs.", name: "Sri Lankan Rupee" },
  LRD: { symbol: "L$", name: "Liberian Dollar" },
  LSL: { symbol: "L", name: "Lesotho Loti" },
  LYD: { symbol: "LD", name: "Libyan Dinar" },
  MAD: { symbol: "DH", name: "Moroccan Dirham" },
  MDL: { symbol: "L", name: "Moldovan Leu" },
  MGA: { symbol: "Ar", name: "Malagasy Ariary" },
  MKD: { symbol: "den", name: "Macedonian Denar" },
  MMK: { symbol: "Ks", name: "Myanmar Kyat" },
  MNT: { symbol: "₮", name: "Mongolian Tögrög" },
  MOP: { symbol: "MOP$", name: "Macanese Pataca" },
  MRU: { symbol: "UM", name: "Mauritanian Ouguiya" },
  MUR: { symbol: "Rs.", name: "Mauritian Rupee" },
  MVR: { symbol: "MRf", name: "Maldivian Rufiyaa" },
  MWK: { symbol: "MK", name: "Malawian Kwacha" },
  MXN: { symbol: "MX$", name: "Mexican Peso" },
  MYR: { symbol: "RM", name: "Malaysian Ringgit" },
  MZN: { symbol: "MTn", name: "Mozambican Metical" },
  NAD: { symbol: "N$", name: "Namibian Dollar" },
  NGN: { symbol: "₦", name: "Nigerian Naira" },
  NIO: { symbol: "C$", name: "Nicaraguan Córdoba" },
  NOK: { symbol: "kr", name: "Norwegian Krone" },
  NPR: { symbol: "Rs.", name: "Nepalese Rupee" },
  NZD: { symbol: "NZ$", name: "New Zealand Dollar" },
  OMR: { symbol: "OR", name: "Omani Rial" },
  PAB: { symbol: "B/.", name: "Panamanian Balboa" },
  PEN: { symbol: "S/.", name: "Peruvian Sol" },
  PGK: { symbol: "K", name: "Papua New Guinean Kina" },
  PHP: { symbol: "₱", name: "Philippine Peso" },
  PKR: { symbol: "Rs.", name: "Pakistani Rupee" },
  PLN: { symbol: "zł", name: "Polish Zloty" },
  PND: { symbol: "$", name: "Pitcairn Islands Dollar" },
  PRB: { symbol: "р.", name: "Transnistrian Ruble" },
  PYG: { symbol: "₲", name: "Paraguayan Guaraní" },
  QAR: { symbol: "QR", name: "Qatari Riyal" },
  RON: { symbol: "L", name: "Romanian Leu" },
  RSD: { symbol: "din", name: "Serbian Dinar" },
  RUB: { symbol: "₽", name: "Russian Ruble" },
  RWF: { symbol: "FRw", name: "Rwandan Franc" },
  SAR: { symbol: "SR", name: "Saudi Riyal" },
  SBD: { symbol: "SI$", name: "Solomon Islands Dollar" },
  SCR: { symbol: "Rs.", name: "Seychellois Rupee" },
  SDG: { symbol: "£SD", name: "Sudanese Pound" },
  SEK: { symbol: "kr", name: "Swedish Krona" },
  SGD: { symbol: "S$", name: "Singapore Dollar" },
  SHP: { symbol: "£", name: "Saint Helena Pound" },
  SLL: { symbol: "Le", name: "Sierra Leonean Leone" },
  SLS: { symbol: "Sl", name: "Somaliland Shilling" },
  SOS: { symbol: "Sh.So.", name: "Somali Shilling" },
  SRD: { symbol: "Sr$", name: "Surinamese Dollar" },
  SSP: { symbol: "SS£", name: "South Sudanese Pound" },
  STN: { symbol: "Db", name: "Sao Tome and Príncipe Dobra" },
  SVC: { symbol: "₡", name: "Salvadoran Colón" },
  SYP: { symbol: "LS", name: "Syrian Pound" },
  SZL: { symbol: "L", name: "Swazi Lilangeni" },
  THB: { symbol: "฿", name: "Thai Baht" },
  TJS: { symbol: "SM", name: "Tajikistani Somoni" },
  TMT: { symbol: "m.", name: "Turkmenistan Manat" },
  TND: { symbol: "DT", name: "Tunisian Dinar" },
  TOP: { symbol: "T$", name: "Tongan Paʻanga" },
  TRY: { symbol: "TL", name: "Turkish Lira" },
  TTD: { symbol: "TT$", name: "Trinidad and Tobago Dollar" },
  TVD: { symbol: "$", name: "Tuvaluan Dollar" },
  TWD: { symbol: "NT$", name: "New Taiwan Dollar" },
  TZS: { symbol: "TSh", name: "Tanzanian Shilling" },
  UAH: { symbol: "₴", name: "Ukrainian Hryvnia" },
  UGX: { symbol: "USh", name: "Ugandan Shilling" },
  USD: { symbol: "$", name: "United States Dollar" },
  UYU: { symbol: "$U", name: "Uruguayan Peso" },
  UZS: { symbol: "сум", name: "Uzbekistani Som" },
  VED: { symbol: "Bs.", name: "Venezuelan bolívar digital" },
  VES: { symbol: "Bs.F", name: "Venezuelan Bolívar Soberano" },
  VND: { symbol: "₫", name: "Vietnamese Dong" },
  VUV: { symbol: "VT", name: "Vanuatu Vatu" },
  WST: { symbol: "T", name: "Samoan Tala" },
  XAF: { symbol: "Fr", name: "Central African CFA Franc BEAC" },
  XCD: { symbol: "$", name: "East Caribbean Dollar" },
  XOF: { symbol: "₣", name: "West African CFA Franc BCEAO" },
  XPF: { symbol: "₣", name: "CFP Franc (Franc Pacifique)" },
  YER: { symbol: "YR", name: "Yemeni Rial" },
  ZAR: { symbol: "R", name: "South African Rand" },
  ZMW: { symbol: "ZK", name: "Zambian Kwacha" },
  ZWL: { symbol: "Z$", name: "Zimbabwean Dollar" },
  unknown: { symbol: "", name: "Unknown currency" },
};

// These are still in active use, and can't be migrated away until we've moved every branding to the new app
export const LEGACY_CURRENCIES = [
  "euro",
  "pound",
  "dollar",
  "yen",
  "franc",
  "ruble",
  "krona",
  "renminbi",
  "won",
  "lira",
  "rupee",
];
export type CurrencyType = (typeof LEGACY_CURRENCIES)[number];

// Legacy to ISO 4217 mapping
export const currencyMapping: Record<CurrencyType, string> = {
  euro: "EUR",
  pound: "GBP", // British
  dollar: "USD", // United States
  yen: "JPY", // Japanese
  franc: "CHF", // Swiss
  ruble: "RUB", // Russian
  krona: "SEK", // Swedish
  renminbi: "CNY", // Chinese
  won: "KRW", // South korean
  lira: "TRY", // Turkish
  rupee: "INR", // Indian
};
